export default [
  {
    path: '/groups',
    component: () => import('./Groups.vue'),
    children: [
      {
        path: '/',
        name: 'groupsList',
        component: () => import('./GroupsList.vue')
      },
      {
        path: 'addGroup',
        name: 'addGroup',
        component: () => import('./GroupForm.vue')
      },
      {
        path: ':id',
        name: 'groupDetails',
        component: () => import('./GroupDetails.vue')
      },
      {
        path: ':id/overrides',
        name: 'groupOverrides',
        component: () => import('@/locations/LocationOverrides.vue')
      },
      {
        path: ':id/edit',
        name: 'editGroup',
        component: () => import('./GroupForm.vue')
      }
    ]
  }
]
